module.exports = __webpack_public_path__ + "static/media/dropdown.27bb0c8f.svg";